// The light box is defined separately
export default class {

    allCcFileUploads = null;
    isFinishedSetupValidationFileStorage = false;

    constructor() {
    }

    init() {

        const self = this;
        this.allCcFileUploads = document.querySelectorAll('.cc-file-upload');

        // populate old values(files) into hidden fields
        this.setupOnErrorFileStorage();
        this.setupOnErrorFilePreview();

        // set time interval until detected isFinishedSetupValidationFileStorage is true to perform alert(1) and turn off the time interval
        let interval = setInterval(() => {
            if (self.isFinishedSetupValidationFileStorage) {
                console.log('finished and go on setup');

                // setup form data on file changes
                self.allCcFileUploads.forEach((ccFileUploadElement) => {
                    self.initiateFilePreview(ccFileUploadElement);
                    ccFileUploadElement.addEventListener('change', (e) => {
                        self.setupRelatedElements(e.target);
                        // this.removePreviousAddedFiles();
                        self.uploadFile();
                    });
                });
                

                clearInterval(interval);
            }
        }, 1000);





    }

    initiateFilePreview(ccFileUploadElement) {
        const previewArea = ccFileUploadElement.closest('.cc-file-upload-wrapper').querySelector('.preview-area');

        const itemJsonDivs = previewArea.querySelectorAll('.items-in-json>div');
        itemJsonDivs.forEach((itemJsonDiv) => {
            const entryData = JSON.parse(itemJsonDiv.dataset.entry);
            this._generateSingleFilePreview(entryData, ccFileUploadElement);
        });

        const errorItemJsonDivs = previewArea.querySelectorAll('.items-in-error-json>div');
        errorItemJsonDivs.forEach((itemJsonDiv) => {
            const entryData = JSON.parse(itemJsonDiv.dataset.entry);
            this._generateSingleFilePreview(entryData, ccFileUploadElement);
        });
    }

    setupOnErrorFilePreview() {

        try {
            const self = this;
            this.allCcFileUploads.forEach((ccFileUploadElement) => {
                const files = (function() {
                    let result = [];

                    const oldElements = document.getElementById('_on_error_file_storage')
                        .querySelectorAll('input[name=_ajax_' + ccFileUploadElement.name.replaceAll('[','\\[').replaceAll(']','\\]') + ']');
                    
                    if (oldElements.length > 0) {
                        result = [...oldElements].map((element) => element.value);
                    }

                    return result;
                })();
                if (!files || files.length < 1) {
                    this.isFinishedSetupValidationFileStorage = true;
                    return false;
                }


                let jsonContainer = ccFileUploadElement.closest('.cc-file-upload-wrapper').querySelector('.items-in-json');
                // wont work if not using callback here
                const data = this._retrieveFilesByPaths(files, function(data) {
                    data.forEach((entryData) => {
                        let itemJsonDiv = document.createElement('div');
                        itemJsonDiv.setAttribute('data-entry', JSON.stringify(entryData));
                        jsonContainer.append(itemJsonDiv);
                    });
                    self.isFinishedSetupValidationFileStorage = true;
                    console.log('dataloading done');
                });

            });
        } catch(error) {
            console.error(error);
            this._displayError(this.currentOperatingInput, error);
        };
    }

    async _retrieveFilesByPaths(files, callback) {
        if (!files || files.length < 1) throw new Error('No files found');

        const self = this;
        const paramString = '?' + files.map((file) => 'paths[]=' + file).join('&');
        console.log('before AJAX');
        const response = await fetch('/find-assets-by-paths' + paramString);

        if (!response.ok) {
            console.log(response.text());
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        if (data.error) { throw new Error(data.error); }

        callback(data);
    }

    // this function is used to handle validation error,
    //    it will populate old values(files) into hidden fields
    setupOnErrorFileStorage() {
        // we are not using cc file upload
        if (document.querySelectorAll('.cc-file-upload').length < 1) return false;

        // show user an alert if the old-value-json is not found
        if (!document.getElementById('old-value-json') || document.getElementById('old-value-json').length < 1) {
            alert( 'Please include ' + `<input type="text" id="old-value-json" value='{{ old | json }}' />` + ' in the form' );
            return false;
        }

        const self = this;

        let oldValuesJson = JSON.parse(document.getElementById('old-value-json').value);

        // filter the oldValuesJson to get only the keys that starts with _ajax_
        let filteredOldValuesJson = Object.keys(oldValuesJson)
            .filter(key => key.startsWith('_ajax_'))
            .reduce((obj, key) => {
                obj[key] = oldValuesJson[key];
                return obj;
            }, {});

        // define inline function for building the hidden input fields
        let recursiveBuild = (key, currentData) => {

            if (Array.isArray(currentData) && typeof currentData.at(0) === 'string') {
                self._generateHiddenFieldsForOnErrorFileStorage(key, currentData);
                // self._generateFilePreviewFromUpload(currentData, self.currentOperatingInput);
            } else {
                for (let keyForNext in currentData) {
                    let dataForNext = currentData[keyForNext];
                    recursiveBuild(key + '[' + keyForNext + ']', dataForNext);
                }
            }

        };

        // recursively build the hidden input fields
        for (let key in filteredOldValuesJson) {
            let currentData = filteredOldValuesJson[key];
            recursiveBuild(key, currentData)
        }
    }

    _generateHiddenFieldsForOnErrorFileStorage(key, files) {

        files.forEach((file) => {
            let hiddenFileNames = document.createElement('input');
            hiddenFileNames.setAttribute('type', 'hidden');
            hiddenFileNames.setAttribute('name', key + '[]');
            hiddenFileNames.setAttribute('value', file);
            document.getElementById('_on_error_file_storage').append(hiddenFileNames);
        });
    }

    setupRelatedElements(element) {
        this.currentOperatingInput = element;
    }

    removePreviousAddedFiles() {
        //return true;
        document.querySelectorAll('input[name=_ajax_' + this.currentOperatingInput.name.replaceAll('[','\\[').replaceAll(']','\\]') + '].on-error-file-storage').forEach((element) => {
            element.remove();
        });
    }
    uploadFile() {
        const collection = this.currentOperatingInput.closest('form').querySelector('[name=_collection]').value ?? '';
        if (collection == '') {
            alert('No collection found');
            return;
        }

        const files = this.currentOperatingInput.files;
        // const file = this.currentOperatingInput.files[0];
        if (!files) {
            alert('No file found');
            return;
        }

        const csrf = this.currentOperatingInput.dataset.csrf;
        if (!csrf) {
            alert('CSRF token not found');
            return;
        }

        const name = this.currentOperatingInput.name;
        if (!name) {
            alert('Name not provided');
            return;
        }

        const formData = new FormData();
        formData.append("_token", csrf);
        for(let i = 0; i < files.length; i++) {
            let file = files[i];
            formData.append('files[]', file);  // hardcode the file to a `file` field
        }
        formData.append("name", name);  // the name here is for retrieving from the blueprint only
        formData.append("collection", collection);

        // the `self` const allows using it inside the fetch
        const self = this;
        fetch('/upload-file', {
            method: 'POST',
            body: formData,
        }).then(response => {
            if (!response.ok) {
                console.log(response.text());
                throw new Error('Network response was not ok');
            }
            return response.json();
        }).then(data => {
            if (data.error) { throw new Error(data.error); }
            self._generateHiddenFieldsForUploadFiles(data.files, name);
            self._generateFilePreviewFromUpload(data.files, self.currentOperatingInput);

        }).catch(error => {
            this._displayError(self.currentOperatingInput, error);
        });
    }

    bindImageRemovals(ccFileUploadElement) {
        let removePictureButtons = ccFileUploadElement.closest('.cc-file-upload-wrapper').querySelectorAll('.remove-picture');
        for(var i = 0; i < removePictureButtons.length; i++) {
            this._bindSingleImageRemoval(removePictureButtons[i]);
        }
    }

    _toggleUploadButton(target) {
        let wrapper = target.closest('.cc-file-upload-wrapper');
        let isBlockMode = wrapper.classList.contains('block-mode');
        let theClassList = isBlockMode ? wrapper.querySelector('label').classList : wrapper.querySelector('input.cc-file-upload').classList;

        // it allows multiple or no file being uploaded
        if (target.hasAttribute('multiple')) {
            theClassList.remove('hidden');
            return;
        }

        // this is single upload
        if (wrapper.querySelectorAll('.items img').length == 0) {
            theClassList.remove('hidden');
            return;
        }

        theClassList.add('hidden');
    }

    _generateHiddenFieldsForUploadFiles(files, name) {

        files.forEach((file) => {
            let hiddenFileNames = document.createElement('input');
            hiddenFileNames.setAttribute('type', 'hidden');
            hiddenFileNames.setAttribute('name', '_ajax_' + name);
            hiddenFileNames.setAttribute('value', file.path);
            hiddenFileNames.classList.add('generate-field-for-ajax-upload');
            this.currentOperatingInput.closest('form').append(hiddenFileNames);

        });
    }

    _generateFilePreviewFromUpload(files, currentOperatingInput) {
        files.forEach((file) => {
            this._generateSingleFilePreview({
                'id': file.id,
                'url': file.url,
                'title': file.title,
                'width': file.width,
                'height': file.height
            }, currentOperatingInput);
        });

    }

    _isVideo(url) {
        return url.match(/\.(mp4|webm|ogg)$/i);
    }

    _generateSingleFilePreview(entryData, correspondingCcFileUploadElement) {

        let itemsDiv = correspondingCcFileUploadElement.closest('.cc-file-upload-wrapper').querySelector('.preview-area>.items');

        // let img = document.createElement('img');
        // img.src = this._isVideo(entryData.url) ? '/images/icons/video.png': entryData.url;

        let img;
        let isVideo = this._isVideo(entryData.url);

        if (isVideo) {
            img = document.createElement('div');
            img.classList.add('video-icon');
            img.innerHTML = '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-m9simb" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="OndemandVideoIcon"><path d="M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2m0 14H3V5h18zm-5-6-7 4V7z"></path></svg>';
        } else {

            img = document.createElement('img');
            img.src = isVideo ? '/images/icons/video.png': entryData.url;
        }

        let removeButton = document.createElement('a');
        removeButton.classList.add('remove-picture');
        removeButton.dataset.field = correspondingCcFileUploadElement.getAttribute('name').replace('[]', '');
         // it is by default using id for entry id in GuestEntryController
        removeButton.dataset.id = itemsDiv.dataset.entryid;
        removeButton.dataset.asset = entryData.id;
        removeButton.dataset.csrf = correspondingCcFileUploadElement.dataset.csrf;
        removeButton.innerHTML = `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="-5.34058e-05" y="10.6064" width="15" height="2" rx="1" transform="rotate(-45 -5.34058e-05 10.6064)" fill="white"/>
        <rect x="1.41409" width="15" height="2" rx="1" transform="rotate(45 1.41409 0)" fill="white"/>
        </svg>
        `;
        this._bindSingleImageRemoval(removeButton);

        let item = document.createElement('a');
        item.id = 'pic-' + itemsDiv.dataset.entryid + '-' + entryData.id;
        item.classList.add('files-wrapper');
        item.setAttribute("href", entryData.url);
        item.setAttribute("data-pswp-width", entryData.width);
        item.setAttribute("data-pswp-height", entryData.height);
        item.setAttribute("data-pswp-type", isVideo ? 'video' : 'image');
        item.append(img);
        item.append(removeButton);

        itemsDiv.append(item);

        // control display of upload button
        this._toggleUploadButton(correspondingCcFileUploadElement);
    }

    _displayError(currentOperatingInput, error) {
        let errorElement = document.createElement('ul');
        errorElement.classList.add('validation-error');

        let errorMessage = document.createElement('li');
        errorMessage.innerText = error;
        errorElement.append(errorMessage);
        currentOperatingInput.parentElement.append(errorElement);
        console.error(error);
    }

    _removeHiddenFieldsForUploadFiles(filename) {
        document.querySelectorAll(".generate-field-for-ajax-upload").forEach((element) => {
            if (element.value == filename) {
                element.remove();
            }
        })
        document.querySelectorAll("#_on_error_file_storage input").forEach((element) => {
            if (element.value == filename) {
                element.remove();
            }
        })
        
    }

    async _removeData(dataset) {
        try {
            const response = await fetch('/!/guest-entries-support/remove-asset', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    _token: dataset.csrf,
                    field: dataset.field,
                    id: dataset.id,
                    asset: dataset.asset
                })
            });
            const result = await response.json();

            let filename = dataset.asset.replace('assets::', '');

            let elementToBeRemoved = document.getElementById("pic-" + dataset.id + "-" + dataset.asset);
            let wrapper = elementToBeRemoved.closest('.cc-file-upload-wrapper');
            elementToBeRemoved.remove();


            this._removeHiddenFieldsForUploadFiles(filename);
            this._toggleUploadButton(
                wrapper.querySelector('.cc-file-upload')
            );

            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }
        } catch (error) {
            console.error(error.message);
        }
    }

    async _bindSingleImageRemoval(element) {
        const self = this;
        element.addEventListener("click", function(event) {
            event.preventDefault();
            event.stopPropagation();
            const agreeToDelete = prompt("This removal would be done straight away, please type `Confirm` to ensure removal.", "");

            if (agreeToDelete != 'Confirm') return false;

            self._removeData(event.currentTarget.dataset);

        });
    }

}